import styled from "styled-components";

import bgPlaceholderPNG from "../../assets/images/placeholder/placeholder_bg.png";

export const Container = styled.div``;

export const Title = styled.h4`
  color: #797881;
  font-size: 24px;
  font-weight: 500;
  text-align: center;
  margin: 20px;
  
  @media(max-width: 720px) {
    font-size: 18px;
  }
`;

export const ContainerPlaceholderByPage = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  background-size: center;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url(${bgPlaceholderPNG});
`;

export const TitlePlaceholderByPage = styled.h4``;

export const ImagePlaceholderByPage = styled.img`
  @media(max-width: 720px) {
    width: 200px;
  }
`;
